import { useQuery } from '@tanstack/react-query';
import { skillApi } from '../skillApi';
import { QueryKey } from '@shared/config';
import { PaginateType } from '@shared/types';

export const useGetSkill = () => {
  return useQuery({
    queryKey: [QueryKey.GET_SKILLS],
    queryFn: () =>
      skillApi.getSkills({
        paginate: PaginateType.NONE,
        filter: {},
      }),
  });
};
